import React, {Component} from 'react'
import {CSSTransition} from 'react-transition-group'
import Modal from '../Modal/Modal'
import StartPage from '../StartPage/StartPage'
import ComparisonTable from '../ComparisonTable/ComparisonTable'
import RemoveModal from '../RemoveModal/RemoveModal'
import styles from './app.module.scss'
import './transition.css'

class App extends Component {
   state = {
      isOpen: false,
      cards: JSON.parse(localStorage.getItem('newCards')),
      removeModal: false,
   }

   openModal = () => {
      this.setState({
         isOpen: true,
         removeModal: false,
      })
      const bodyRef = document.querySelector('body')
      bodyRef.style.overflowY = 'hidden'
   }

   closeModal = () => {
      localStorage.clear()
      this.setState({
         isOpen: false,
      })
      const bodyRef = document.querySelector('body')
      bodyRef.style.overflowY = 'scroll'
   }

   compareCards = () => {
      this.setState({
         cards: JSON.parse(localStorage.getItem('newCards')),
         isOpen: false,
      })
      const bodyRef = document.querySelector('body')
      bodyRef.style.overflowY = 'scroll'
   }

   removeCards = () => {
      localStorage.clear()
      this.setState({
         removeModal: true,
         cards: null,
      })
      const bodyRef = document.querySelector('body')
      bodyRef.style.overflowY = 'hidden'
   }

   closeSmallModal = () => {
      this.setState({
         removeModal: false,
      })
      const bodyRef = document.querySelector('body')
      bodyRef.style.overflowY = 'scroll'
   }

   componentWillUnmount() {
      this.compareCards()
      localStorage.clear()
   }

   render() {
      const {isOpen, cards, removeModal} = this.state
      return (
         <>
            <div className={styles.comparison}>
               <StartPage openModal={this.openModal} cards={cards} removeCards={this.removeCards} />
               {cards ? <ComparisonTable cards={cards} /> : ''}
            </div>
            <CSSTransition classNames='modalAnimation' timeout={500} in={isOpen} unmountOnExit>
               <Modal compareCards={this.compareCards} closeModal={this.closeModal} />
            </CSSTransition>
            <CSSTransition classNames='modalAnimation' timeout={500} in={removeModal} unmountOnExit>
               <RemoveModal closeModal={this.closeSmallModal} openModal={this.openModal} />
            </CSSTransition>
         </>
      )
   }
}

export default App